import {
  AccountCapacityTypeahead,
  AccountDayEquipmentTypeStat,
} from '~hooks/useAccount/models';

export class CapacityBreakdownRow {
  constructor(
    private _vendor: AccountCapacityTypeahead,
    private _equipment_type_stat: AccountDayEquipmentTypeStat,
  ) {}

  public get id() {
    return this._equipment_type_stat.id;
  }

  public get vendor() {
    return this._vendor;
  }

  public get equipmentType() {
    return this._equipment_type_stat.equipmentType;
  }

  public get committedCount() {
    return this._equipment_type_stat.committedCount;
  }

  public get assignedCount() {
    return this._equipment_type_stat.assignedCount;
  }

  public static fromVendor(vendor: AccountCapacityTypeahead, equipmentTypeId?: string) {
    return vendor.equipmentTypeStats
      .filter((stat) => !equipmentTypeId || stat.equipmentType.id === equipmentTypeId)
      .map((stat) => new CapacityBreakdownRow(vendor, stat));
  }
}
